'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vi_VN = require('../../date-picker/locale/vi_VN');

var _vi_VN2 = _interopRequireDefault(_vi_VN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _vi_VN2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/calendar/locale/vi_VN.tsx
 ** module id = 772
 ** module chunks = 1
 **/